const isPathWithin = (pathname: string, root: string): boolean =>
  pathname === root || pathname.startsWith(`${root}/`)

export const isAnonymousPublicRoute = (pathname: string): boolean =>
  isPathWithin(pathname, '/public')

const isAnonymousPublicRequest = (requestUrl: string | undefined): boolean => {
  if (!requestUrl) return false

  try {
    const pathname = new URL(requestUrl, 'https://buildlog.local').pathname

    return isPathWithin(pathname, '/public') || isPathWithin(pathname, '/api/public')
  } catch {
    return false
  }
}

export const shouldRedirectUnauthorizedToLogin = (
  pathname: string,
  requestUrl: string | undefined,
): boolean => !isAnonymousPublicRoute(pathname) && !isAnonymousPublicRequest(requestUrl)

export const shouldShowMaintenanceOverlay = (
  isMaintenance: boolean,
  isSpecialUser: boolean,
  pathname: string,
): boolean =>
  isMaintenance && !isSpecialUser && pathname !== '/login' && !isAnonymousPublicRoute(pathname)
